module.exports = __webpack_public_path__ + "static/media/cdb20.e0b53f41.png";